import {
  HttpClient,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from "@angular/core";
import { from, Observable, throwError } from "rxjs";
import { timeout, tap, catchError } from "rxjs/operators";
import { environment } from "../../environments/environment";

@Injectable()
export class LogInterceptor implements HttpInterceptor {
    constructor(private httpClient: HttpClient) {}
    client: any;

    private applyHeaer() {
        return
    }

    private async handleAccess(req: HttpRequest<any>, next: HttpHandler):
		Promise<HttpEvent<any>> {

        localStorage.setItem('urlIp', environment.URL.IP_USUARIO);

        await this.loadIp().then((data) => {
            this.client = data;
        }).catch(() => {
            this.client = {
                ip: 'null'
            }
        });

        let token = localStorage.getItem('bway-token');

        const decodedPayload = this.decodeJwtPayload(token);

        let clientId = decodedPayload != null && decodedPayload.empresaId != null ? decodedPayload.empresaId : null;
        let usuario = decodedPayload != null && decodedPayload.login != null ? decodedPayload.login : null;
        let memberId = decodedPayload != null && decodedPayload.acessoId != null ? decodedPayload.acessoId : null;

        let logHeader = {
            "tela": window.location.href,
            "hostForward": this.client.ip,
            "clientId":clientId,
            "usuario": usuario,
            "memberId": memberId
        };

        const output = req.clone({
            headers: req.headers.set('logHeader', JSON.stringify(logHeader)),
        });

        return next.handle(output).pipe(tap(event => event), catchError(err => {
			return throwError(err);
		})).toPromise();
    }

    decodeJwtPayload(jwt: string): any {
        if(jwt == null) return null;
        const base64Url = jwt.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        const fullDecodedString = atob(base64);
        const jsonEndPosition = fullDecodedString.indexOf('};') + 1;
        let jsonPayload = fullDecodedString.substring(0, jsonEndPosition + 1);
        jsonPayload = jsonPayload.replace(/;+$/, '');
        return JSON.parse(jsonPayload);
    }

  loadIp() {
    const headers = new HttpHeaders();
    // Exclude unnecessary headers
    return Promise.resolve(this.httpClient.get(environment.URL.IP_USUARIO, { headers: headers })
      .pipe(timeout(4000)).toPromise());
  }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (req.method == 'GET')
            return next.handle(req);

        return from(this.handleAccess(req, next));
    }

}
